import { Injectable } from '@angular/core';
import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  // private timer = 4500;
  private timer = 7000;

  constructor() { }

  success(message: string): void {
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Tudo certo !',
      text: message,
      showConfirmButton: false,
      timer: this.timer
    });
  }

  error(message: string): void {
    Swal.fire({
      position: 'center',
      icon: 'info',
      title: 'Ops !',
      text: message,
      showConfirmButton: false,
      timer: this.timer
    });
  }

  warning(message: string): void {
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Aviso!',
      text: message,
      showConfirmButton: false,
      timer: this.timer
    });
  }

  info(message: string): void {
    Swal.fire({
      position: 'center',
      icon: 'info',
      title: 'Atenção!',
      text: message,
      showConfirmButton: false,
      timer: this.timer
    });
  }

  question(message: string): void {
    Swal.fire({
      position: 'center',
      icon: 'question',
      title: message,
      showConfirmButton: false,
      timer: this.timer
    });
  }

}
